module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/fraternity-mobile-5a65504a904c61eea1fef6a528e8bf6e.jpg";